import React from 'react';
import Widget from '../../../../GenericComponents/Widget/Widget';

export default function Bill() {
  return (
    <Widget weight='h-1/4' rounded='rounded-b-lg'>
        Bill
    </Widget>
  )
}
